<template>
  <v-container>
    <v-dialog v-model="openFlag" fullscreen hide-overlay transition="dialog-bottom-transition">
      <c-card class="white">
        <v-toolbar dark color="primary">
          <c-btn iconName="mdi-close" @click="cancelFlag = true" elevation="0" color="primary"></c-btn>
          <v-toolbar-title>수동 배차</v-toolbar-title>
        </v-toolbar>

        <v-row justify="center">
          <div class="schedule-wrapper">
            <v-container>
              <v-row class="mt-10 mx-5" style="height: 40px">
                <v-menu
                  :close-on-content-click="false"
                  v-model="startMenu"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div style="width:200px">
                      <v-text-field
                        label="예약일자"
                        v-model="selectedDate"
                        prepend-icon="event"
                        readonly dense
                        v-on="on"
                        :disabled="selectedDateFlag"
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker
                    v-model="selectedDate"
                    firstDayOfWeek="1" noTitle="true" scrollable="true"
                    :allowedDates="allowedDates"
                    :selectedDate="selectedDate"
                    locale="ko-kr"
                    @input="startMenu = false"
                  ></c-date-picker>
                </v-menu>

                <c-time-picker
                  label="예약시간"
                  v-model="selectedTime"
                  :minute-interval="5"
                  :h-range="[0,24]"
                  :autoScroll="true"
                  :defaultAutoScrollValue="7"
                  inputWidth="200px"
                  :readonly="false"
                />
                <c-btn class="blue mx-3" @click="onReserve" :disabled="assignBtnStatus">배차</c-btn>

                <v-spacer></v-spacer>
              </v-row>

              <v-row class="pt-3 pb-5" align="center" justify="end" style="height: 20px">
                <div class="schedule-index__item" style="background-color: #bbbbbb;"/>
                <div class="schedule-index__text">퇴근/휴무</div>

                <div class="schedule-index__item" style="background-color: #f7b632;"/>
                <div class="schedule-index__text">예약</div>

                <div class="schedule-index__item" style="background-color: #2cccc7;"/>
                <div class="schedule-index__text">휴식</div>
              </v-row>
            </v-container>

            <c-scheduler class="mt-3"
                         :headerList="getHeaderList"
                         :contentList="schedulerContentList"
                         :guideLine="timeGuideLine"
                         @onClickContentRow="onClickSchedule"
                         :contentsHeight="calHeight"
            >
              <template #contentItem="{item}">
                <v-tooltip bottom v-if="item.item">
                  <template v-slot:activator="{ on }">
                    <div style="width: 100%; height: 100%" @mouseover="on.mouseenter" @mouseleave="on.mouseleave"/>
                  </template>
                  <div>예약자: {{item.item.info.customerName}}</div>
                  <div>구분: {{item.item.info.suburbanType}}</div>
                  <div>출발지: {{item.item.info.departure}}</div>
                  <div>도착지: {{item.item.info.destination}}</div>
                  <div>출발시간: {{item.item.info.startTime}}</div>
                  <div>종료시간: {{item.item.info.endTime}}</div>
                </v-tooltip>
              </template>
            </c-scheduler>
          </div>
        </v-row>
      </c-card>

      <!-- 배차 취소 팝업 표시 -->
      <v-dialog v-model="cancelFlag" width="400">
        <c-card class="white">
          <div class="pt-5 pb-3 text-center">수동 배차를 취소하시겠습니까?</div>
          <v-col cols="12">
            <c-btn block large color="blue" @click="closeAll">예 (배차 대기)</c-btn>
          </v-col>
          <v-col cols="12">
            <c-btn block large color="black" @click="cancelFlag = false">아니오</c-btn>
          </v-col>
        </c-card>
      </v-dialog>
    </v-dialog>
  </v-container>
</template>

<script>
  import CScheduler from "@/views/Default/Common/CScheduler";
  export default {
    components: {CScheduler},
    props: {
      open: {
        type: Boolean,
        default: false
      },
      reservationCheckData: {
        type: Object,
      },
      reservationFlag: {
        type: Boolean
      }
    },
    data() {
      return {
        openFlag: false,
        cancelFlag: false,
        selectedTime: '00:00',
        selectedDate: this.$func.curDateString(),
        reservationDuration: 0,
        timeGuideLine: {
          startLeft: 0,
          endLeft: 0,
          color: 'red',
        },
        schedulerHeaders: [0, 24],
        schedulerOneMinuteWidth: 1,
        schedulerContentList: {},
        selectedSchedule: {},
        disableBreakTime: true, // 휴무 제외 플래그
        calHeight: 0,
        startMenu: false,
        assignBtnStatus: false,
        assignBtnCount : 0
      }
    },
    watch: {
      open(newVal) {
        if(newVal) {
          //init data
          const schedulerHeight = window.innerHeight - 370;
          this.calHeight = schedulerHeight < 300? 300: schedulerHeight;
          this.selectedSchedule = {};
          this.schedulerContentList = {};
          this.disableBreakTime = true;

          const reservationData = this.reservationCheckData.reservationList;
          if(reservationData && reservationData.length > 0) {
            const startDateTime = this.$func.stringToDatetime(reservationData[0].startTime);
            this.selectedDate = startDateTime.format('YYYY-MM-DD');
            this.selectedTime = startDateTime.format('HH:mm');
            this.reservationDuration = Math.ceil(reservationData[0].driveTime/1000/60) + reservationData[0].serviceTime;
            this.reqGetScheduleList();
          }
        }
        this.openFlag = newVal;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      selectedDate(newVal) {
        this.selectedSchedule = {};
        this.reqGetScheduleList(newVal);
      },
      selectedTime(newVal) {
        const selectedSchedule = {...this.selectedSchedule};
        const driverIds = Object.keys(selectedSchedule);
        for(let i=0; driverIds && i<driverIds.length; i++) {
          this.deSelectedSchedule(driverIds[i]);
        }

        const startLeft = this.schedulerOneMinuteWidth * parseInt(this.$moment.duration(this.$moment(newVal, 'HH:mm').diff(this.$moment(this.schedulerHeaders[0], 'H'))).asMinutes());
        const endLeft = startLeft + this.reservationDuration * this.schedulerOneMinuteWidth;
        this.timeGuideLine = {
          ...this.timeGuideLine,
          startLeft,
          endLeft
        }
      },
      disableBreakTime(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.selectedSchedule = {};
          this.reqGetScheduleList();
        }
      },
    },
    computed: {
      getHeaderList() {
        let headerList = [];
        for (let i = this.schedulerHeaders[0]; i < this.schedulerHeaders[1]; i++) {
          headerList.push(this.$moment({hour: i}).format('HH:00'));
        }
        return headerList;
      },
      selectedDateFlag() {
        const userRole = this.$store.state.userInfo.role;
        return userRole === 'TM';
      }
    },
    methods: {
      allowedDates(date) {
        return !this.$moment(date, 'YYYY-MM-DD').isBefore(this.$moment('00:00:00', 'HH:mm:ss'));
      },
      onReserve() {
        const reservationCnt = this.reservationCheckData.reservationList.length;
        //selectTime Format이 HH:m인 경우 padStart로 HH:mm으로 변환
        this.selectTimeHour = this.selectedTime.slice(0,2)
        this.selectedTime = this.selectedTime.length === 4 ? this.selectTimeHour+':'+this.selectedTime.slice(3,4).padStart(2, '0') : this.selectedTime;
        const reservationTime = this.$moment(this.selectedDate + ' ' +this.selectedTime);

        const nowTime = this.$moment();

        if(reservationTime.isBefore(nowTime)){
          this.$store.commit('snackbar', {msg: '과거 시간은 예약이 불가능합니다. 시간을 다시 설정해주세요.'});
          return;
        } else if(reservationCnt !== Object.keys(this.selectedSchedule).length) {
          this.$store.commit('snackbar', {msg: '배차되지 않은 예약이 존재합니다.'});
          return;
        }

        this.assignBtnCount += 1;
        this.assignBtnStatus=true
        if(this.assignBtnCount === 1) {
          this.reqReserve();
        }

        // this.openFlag = false;
      },
      // 선택된 스케줄 해제 // param : 차량id, 기사id, 선택된 스케줄 배열의 idx
      deSelectedSchedule(driverId) {
        let findDriveInedx = this.schedulerContentList.findIndex(content => { return content.driverId === driverId })

        this.schedulerContentList[findDriveInedx].subContents.forEach( (subContent, subIndex) => {
            this.schedulerContentList[findDriveInedx]
            .subContents[subIndex]
            .items.splice(-1, 1);
        })

        delete this.selectedSchedule[driverId];
      },
      onClickSchedule(schedule) {
        const availableCnt = this.reservationCheckData.reservationList.length;
        const {vehicleId, driverId, items} = schedule;

        let findDriveInedx = this.schedulerContentList.findIndex(content => { return content.driverId === driverId })

        let findDrvieSubIndex = this.schedulerContentList[findDriveInedx].subContents.findIndex(contentSub => {
          return contentSub.driverId === driverId && contentSub.vehicleId === vehicleId
        })

        // - 클릭된 데이터 선택/해제 확인
        if(this.selectedSchedule[driverId]) {
          this.deSelectedSchedule(driverId);
          return;
        }

        // - 선택 가능 개수 확인
        //   - availableCnt 초과시 알림창
        else if(Object.keys(this.selectedSchedule).length >= availableCnt) {
          this.$store.commit('snackbar', {msg: '선택 가능한 개수를 초과하였습니다.'});
          return;
        }

        // - 가능 스케줄인지 확인
        //   - 불가능할 경우 알림창
        if(items.length < 2) { //휴무
          this.$store.commit('snackbar', {msg: '예약 가능한 시간이 아닙니다.'});
          return;
        } else {
          const {startLeft, endLeft} = this.timeGuideLine;
          let flag = false;

          // length=3이상, 출퇴근 시간 외 스케줄이 있는 경우
          if(items.length > 2) {
            // 출퇴근 시간 외 스케줄에서 비교
            for(let i=0; i<items.length - 3; i++) {
              if(items[i].left + items[i].width <= startLeft && items[i+1].left >= endLeft) {
                flag = true;
                break;
              }
            }

            // [출근,첫예약], [마지막예약,퇴근] 사이 비교
            // items[items.length-1] //퇴근
            // items[items.length-2] //출근
            // items[items.length-3] //마지막예약
            // items[0] //첫예약
            // 출퇴근시간 포함
            if((items[items.length-2].width <= startLeft && items[0].left >= endLeft) ||
              ((items[items.length-3].left + items[items.length-3].width) <= startLeft && items[items.length-1].left >= endLeft)) {
              flag = true;
            }
          }
          // length=2, 출퇴근 시간만 있는 경우 // items[0] - 출근, items[1] - 퇴근
          else if(items[0].width <= startLeft && items[1].left >= endLeft) {
            flag = true;
          }

          if(flag) { // 가능한 경우
            this.schedulerContentList[findDriveInedx]
              .subContents[findDrvieSubIndex]
              .items.push({
              color: 'red',
              width: this.timeGuideLine.endLeft - this.timeGuideLine.startLeft,
              left: this.timeGuideLine.startLeft
            });

            //동일 기사 스케줄 찾기
            const findVehicleIdsByDriverId = Object.keys(this.schedulerContentList).filter(
              key => {
                return (key !== vehicleId) && (Object.keys(this.schedulerContentList[key].subContents).indexOf(driverId) > -1)
            });

            //다른 차량 체크
            let restIndexs = Object.keys(this.schedulerContentList[findDriveInedx].subContents).filter(index => index !== String(findDrvieSubIndex))
            restIndexs.forEach(restIndex => {
              this.schedulerContentList[findDriveInedx].subContents[restIndex].items.push({
                color: 'rgba(256, 0, 0, 0.4)',
                width: this.timeGuideLine.endLeft - this.timeGuideLine.startLeft,
                left: this.timeGuideLine.startLeft
              })
            })

            this.selectedSchedule[driverId] = [vehicleId, ...findVehicleIdsByDriverId];
          } else {
            this.$store.commit('snackbar', {msg: '예약 가능한 시간이 아닙니다.'});
          }

        }
      },

      async reqReserve() {
        try {
          const rsvData = this.reservationCheckData.reservationList;
          const driverIds = Object.keys(this.selectedSchedule);
          let assign = [];
          const startTime = this.selectedDate + ' ' + this.selectedTime + ':00';
          const arriveTime = this.$moment(startTime, 'YYYY-MM-DD HH:mm:ss').add(rsvData[0].driveTime, 'ms').format('YYYY-MM-DD HH:mm:ss');
          const endTime = this.$moment(arriveTime, 'YYYY-MM-DD HH:mm:ss').add(rsvData[0].serviceTime, 'm').format('YYYY-MM-DD HH:mm:ss');

          for(let i=0; i<rsvData.length; i++) {
            const driverId = driverIds[i];
            assign.push({
              id: rsvData[i].id,
              vehicleId: this.selectedSchedule[driverId][0],
              driverId,
              startTime,
              endTime,
              arriveTime
            });
          }
          const reqData = {
            reservationId: rsvData[0].reservationId,
            assignList : assign
          };

          /* 예약현황에서 바로 수동배차로 넘어올 경우, '예약 대기' 상태로 변경 후 수동배차 진행 */
          if(rsvData[0].resrvState.configValue == 'rs_complete') {
            const sendJson = {
              reservationId: rsvData[0].reservationId,
              configString : 'rs_receipt'
            }
            await this.$api.changeReservationState(sendJson);
          }

          await this.$api.manualReservation(reqData).catch(() => {throw "예약에 실패하였습니다."});
          const res = await this.$api.getReservationWithPassengers(reqData.reservationId);

          // this.reservationWithPassenger = res.data;

          let resCheckData = {
            // passengerList:  this.reservationCheckData.passengerList,
            passengerList:  res.data.passengerList,
            reservationList : res.data.reservationList,
          };

          this.$emit('update:reservationCheckData', resCheckData);
          this.$emit('update:reservationFlag', "success");
          // info alert띄움, 확인 클릭하면 details 페이지로 이동
          this.openFlag = false;

          this.$store.commit('snackbar', {color: 'blue', timeout: 2000, msg: '예약이 완료되었습니다.'});

        } catch(err) {
          this.$emit('update:reservationFlag', "failure");
          this.$store.commit('alert',
            {
              err, where:'onReserve',
              open: true, persistent: true,
              callBack: () => {
                this.openFlag = false;
              }
            });
        } finally {
          this.assignBtnStatus =false;
          this.assignBtnCount = 0;
        }
      },

      checkVehicleOption(reservationVehicleOptions, vehicleOption) {
        const centerVehicleOptions = vehicleOption.split(',');
        const isInclude = centerVehicleOptions.filter(centerVehicleOption => reservationVehicleOptions.includes(centerVehicleOption)).length > 0;
        if(isInclude) {
          return true;
        }
        //사용자가 예약한 옵션이 있는 차량이 아님.
        return false;
      },

      async reqGetScheduleList(selectedDate) {
        try {
          const reservationCheckData = this.reservationCheckData.reservationList[0]
          const res = await this.$api.getReservationScheduleByDateNew(selectedDate || this.selectedDate, reservationCheckData.reservationId);

          const vehicleTypeList = reservationCheckData.vehicleType.split(',');

          let reservationVehicleOptions = null;

          if(reservationCheckData.vehicleOption) {
            reservationVehicleOptions = reservationCheckData.vehicleOption.includes('c_all') ? null : reservationCheckData.vehicleOption.split(',');
          }

          let contentList = [];

          res.data.driverList.forEach( vehicle => {

            //사용자가 특정 차량옵션을 선택한경우, vehicle이 옵션을 장착했는지 확인
            if(reservationVehicleOptions) {
              //예약시 선택한 차량옵션과 일치하지않으면 list에 표시하지 않음.
              if(!this.checkVehicleOption(reservationVehicleOptions, vehicle.vehicleOption)) return;
            }

            let findInedx = contentList.findIndex(content => { return content.driverId === vehicle.driverId })

            if ( findInedx === -1) {
              contentList.push(
                {
                  title: vehicle.driverName,
                  driverId: vehicle.driverId,
                  subContents: [
                    {
                      title: vehicle.plateNo,
                      driverId: vehicle.driverId,
                      vehicleId: vehicle.vehicleId,
                      items: this.setWorkTime(vehicle)
                    }
                  ]
                }
              );
            }else {
              contentList[findInedx].subContents.push(
                {
                  title: vehicle.plateNo,
                  driverId: vehicle.driverId,
                  vehicleId: vehicle.vehicleId,
                  items: this.setWorkTime(vehicle)
                }
              )
            };
          })

          res.data.reservationList.forEach( (reservation) => {
            //동일한 예약인 경우 제외
            if(reservation.reservationId === this.reservationCheckData.reservationList[0].reservationId) return;

            let findDriveInedx = contentList.findIndex(content => { return content.driverId === reservation.driverId })

            //기사가 없을 경우 제외
            if(findDriveInedx === -1) return;


            let findDrvieSubIndex = contentList[findDriveInedx].subContents.findIndex(contentSub => {
              return contentSub.driverId === reservation.driverId && contentSub.vehicleId === reservation.vehicleId
            })

            //기사에 차량이 없을 경우 제외
            if(findDrvieSubIndex === -1) return;

            if( reservation.customerName === reservation.departure && reservation.customerName === reservation.destination ) {
              //휴식
              contentList[findDriveInedx].subContents[findDrvieSubIndex].items.unshift( this.setDriveTime(reservation, '#2cccc7') )
            }else {
              //배차
              contentList[findDriveInedx].subContents[findDrvieSubIndex].items.unshift( this.setDriveTime(reservation, '#f7b632') )

              //다른 차량 휴식
              let restIndexs = Object.keys(contentList[findDriveInedx].subContents).filter(index => index !== String(findDrvieSubIndex))
              restIndexs.forEach(restIndex => {
                contentList[findDriveInedx].subContents[restIndex].items.unshift( this.setRestTime(reservation, '#e1e1e1') )
              })
            }
          })

          let sortcontentList = [];
          contentList.forEach( sub => {
            sub.subContents = sub.subContents.sort( (a, b) => a.name < b.name ? -1 : a.name > b.name ? 1: 0 );
            sortcontentList.push(sub);
          })

          this.schedulerContentList = contentList;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetScheduleList'});
        }
      },

      setDriveTime(reservation, color) {
        let width = 0;
        let left = 0;

        const startTimeM = this.$func.stringToDatetime(reservation.startTime);
        const endTimeM = this.$func.stringToDatetime(reservation.endTime);

        const diff = parseInt(this.$moment.duration(endTimeM.diff(startTimeM)).asMinutes());
        if (diff > 0) {
          width = diff * this.schedulerOneMinuteWidth;
          const diffWithStart = parseInt(this.$moment.duration(startTimeM.diff(this.$moment(startTimeM.format('YYYY-MM-DD')+' '+this.schedulerHeaders[0], 'YYYY-MM-DD H'))).asMinutes());
          left = diffWithStart * this.schedulerOneMinuteWidth;
        } else {
          // TODO - check case
          console.log('check others/ reservation: ', reservation);
        }

        return {
          color: color,
          width,
          left: left<0? 0: left,
          item : {
            info: {
              customerName: reservation.customerName,
              suburbanType: `${this.getSuburbanString(reservation)}/${this.getTripTypeString()}`,
              departure: reservation.departure,
              destination: reservation.destination,
              startTime: reservation.startTime,
              endTime: reservation.endTime
            }
          }
        };
      },

      setRestTime(reservation, color) {
        let width = 0;
        let left = 0;

        const startTimeM = this.$func.stringToDatetime(reservation.startTime);
        const endTimeM = this.$func.stringToDatetime(reservation.endTime);

        const diff = parseInt(this.$moment.duration(endTimeM.diff(startTimeM)).asMinutes());
        if (diff > 0) {
          width = diff * this.schedulerOneMinuteWidth;
          const diffWithStart = parseInt(this.$moment.duration(startTimeM.diff(this.$moment(startTimeM.format('YYYY-MM-DD')+' '+this.schedulerHeaders[0], 'YYYY-MM-DD H'))).asMinutes());
          left = diffWithStart * this.schedulerOneMinuteWidth;
        } else {
          // TODO - check case
          console.log('check others/ reservation: ', reservation);
        }

        return {
          color: color,
          width,
          left: left<0? 0: left,
          item : null
        };

      },

      setWorkTime(vehicle) {
        let items = [];
        let width = 0;
        let left = 0;

        const workOffColor = '#808080';

        const displayStartTimeM = this.$moment(this.schedulerHeaders[0], 'H');
        const displayEndTimeM = this.$moment(this.schedulerHeaders[1], 'H');
        let workTimeM = this.$moment(vehicle.onWorkTime, 'HH:mm');
        let endWorkTimeM = this.$moment(vehicle.endWorkTime, 'HH:mm');

        // 근무시작시간이 display된 시간보다 작은 경우
        if(workTimeM.diff(displayStartTimeM) < 0) {
          workTimeM = displayStartTimeM;
        }
        //근무종료시간이 display된 시간보다 작은 경우
        if(endWorkTimeM.diff(displayStartTimeM) < 0) {
          endWorkTimeM = displayStartTimeM;
        }
        //근무시작시간이 display 된 시간보다 큰 경우
        if(displayEndTimeM.diff(workTimeM) < 0) {
          workTimeM = displayEndTimeM;
        }
        //근무종료시간이 display된 시간보다 큰 경우
        if(displayEndTimeM.diff(endWorkTimeM) < 0) {
          endWorkTimeM = displayEndTimeM;
        }

        const diffWithStart = parseInt(this.$moment.duration(workTimeM.diff(displayStartTimeM)).asMinutes());
        width = diffWithStart * this.schedulerOneMinuteWidth;
        items.push({
          color: workOffColor,
          width: width < 0 ? 0 : width,
          left: left < 0 ? 0 : left,
        });

        width = parseInt(this.$moment.duration(displayEndTimeM.diff(endWorkTimeM)).asMinutes())
          * this.schedulerOneMinuteWidth;
        left = parseInt(this.$moment.duration(endWorkTimeM.diff(displayStartTimeM)).asMinutes())
          * this.schedulerOneMinuteWidth;

        items.push({
          color: workOffColor,
          width: width < 0 ? 0 : width,
          left: left < 0 ? 0 : left,
        });

        return items;
      },

      getSuburbanString(reservation) {
        if (!reservation || !reservation.fareType) {
          return '';
        }

        return reservation.fareType.startsWith('suburban') ? '시외' : '시내';
      },

      getTripTypeString() {
        return '편도';
      },

      closeAll() {
        this.$emit('initData');
        this.cancelFlag = false;
        this.openFlag = false;
      }
    }
  }
</script>

<style scoped>
  .schedule-wrapper {
    width: 1300px;
    overflow-x: auto
  }
  .schedule-index__item {
    width: 20px;
    height: 14px;
    margin-left: 20px;
    margin-right: 5px
  }
  .schedule-index__text {
    font-size: 14px;
  }
</style>
